<template>
  <div class="mb-5">
    <div class="text-center my-3">
      <span
        class="text-primary h5 font-weight-bold cursor-pointer"
        @click="changeWeek(-1)">
        &laquo;
      </span>

      <span class="mx-2 py-2">
        {{formatDate(dateFrom, 'd.m.y')}} - {{formatDate(dateTo, 'd.m.y')}}
      </span>

      <span
        class="text-primary h5 font-weight-bold cursor-pointer"
        @click="changeWeek(1)">
        &raquo;
      </span>
    </div>

    <div class="text-center my-3">
      <div
        v-for="(day, dayKey) in days"
        :key="dayKey"
        :class="'py-2 btn rounded-circle mx-2 ' + (day.isCurrent ? 'btn-primary' : 'btn-link')"
        @click="selectDay(day.date)">
        {{day.name}}
      </div>
    </div>
  </div>
</template>

<script>
import {MS_IN_DAY, CALENDAR_DAY_ABBR} from '../../../../constants';
import formatDate from '../../../../utils/formatDate';

export default {
  name: 'ClientDrugSchedulePager',

  props: ['date', 'setDate'],

  data() {
    return {};
  },

  computed: {
    dateFrom() {
      const shift = this.date.getDay() === 0 ? 6 : this.date.getDay() - 1;

      return new Date(this.date.getTime() - shift * MS_IN_DAY);
    },

    dateTo() {
      return new Date(this.dateFrom.getTime() + 6 * MS_IN_DAY);
    },

    days() {
      const days = [];
      const from = this.dateFrom.getTime();
      const to = this.dateTo.getTime();

      for (let i = from; i <= to; i += MS_IN_DAY) {
        const date = new Date(i);

        days.push({
          date,
          name: CALENDAR_DAY_ABBR[date.getDay()],
          isCurrent: this.date.getDay() === date.getDay(),
        });
      }

      return days;
    },
  },

  methods: {
    changeWeek(step) {
      const date = new Date(this.date.getTime() + step * 7 * MS_IN_DAY);

      this.$emit('change-date', date);
    },

    selectDay(date) {
      this.$emit('change-date', date);
    },

    formatDate(date, format) {
      return formatDate(date, format);
    },
  }
};
</script>
